var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8153 1.29581C16.2879 0.823273 17.0547 0.823273 17.5273 1.29581C17.9994 1.76826 17.9994 2.53427 17.5273 3.00674L11.122 9.41104L17.5273 15.8153C17.9997 16.2879 17.9998 17.0547 17.5273 17.5273C17.0547 17.9998 16.2879 17.9997 15.8153 17.5273L9.41104 11.122L3.00674 17.5273C2.53427 17.9994 1.76826 17.9994 1.29581 17.5273C0.823273 17.0547 0.823273 16.2879 1.29581 15.8153L7.69913 9.41104L1.29581 3.00674C0.823308 2.53421 0.823285 1.76833 1.29581 1.29581C1.76833 0.823285 2.53421 0.823308 3.00674 1.29581L9.41104 7.69913L15.8153 1.29581Z",
    fill: "#676E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fe38232ad035665d4593be9dbb74ef46.svg";
export { ForwardRef as ReactComponent };